/**
@ngdoc directive
@name favouritesStar

@description
Staring favourites items.
*/

(function() {
    'use strict';

    var favouritesStar = function($timeout, ajaxCall, $templateCache) {
        return {
            restrict: "EA",
            replace: true,
            transclude: false,
            scope: true,
            bindToController: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                isFavourite: "<", // Switched this to one-way binding. Assuming the boolean when changed doesn't need to feedback to outside model. This will allow gc to separate these
                ajaxContentUrl: "@" // we want to expose loading, so we can disable button while the results are being loaded
            },
            controllerAs: "ctrl",
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                $timeout(function(){
                    _this.isFavourite = (_this.isFavourite === "true" || _this.isFavourite === true);
                });

                _this.toggleFavourite = function(e){
                    _this.isFavourite = !_this.isFavourite;
                    ajaxCall.getData(_this.ajaxContentUrl + "&isFavourite=" + _this.isFavourite).then(
                        function(response){ },
                        function(response){ }
                    );
                }

            }],
            template: $templateCache.get('components/favouritesStar.html')
        };
    };
    favouritesStar.$inject = ['$timeout', 'ajaxCall', '$templateCache'];
    angular.module('app').directive('favouritesStar', favouritesStar);

}());
